import React, {Component} from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import ClientsTable from "./ClientsTable";
import ClientCreateModal from "./ClientCreateModal";
import {checkPermission, CAN_CREATE_CLIENTS} from "../../../lib/permissions";

export default class Clients extends Component {

    state = {
        createClientOpen: false
    }

    toggleCreate = () => {
        this.setState({createClientOpen: !this.state.createClientOpen})
    }

    render() {

        return (
            <div className="d-flex flex-column">
                <div className="d-flex flex-row align-items-center justify-content-end p-3">
                    {checkPermission(CAN_CREATE_CLIENTS) && <Button
                        size="sm"
                        color="success"
                        onClick={this.toggleCreate}
                    >
                        <FontAwesomeIcon
                            color="#fff"
                            icon="plus"/>{' '}
                        Add Client
                    </Button>}
                </div>
                <ClientsTable/>
                <ClientCreateModal
                    isOpen={this.state.createClientOpen}
                    toggle={this.toggleCreate}
                />
            </div>
        )

    }

}